import { waitFor, fireEvent } from '@testing-library/react';
import { logActiveElement } from './utils';

export const wait = (timeout?: number) => waitFor(() => {}, { timeout });

// spy on console.og and suppress it
const jestLog = jest.spyOn(console, 'log').mockImplementation(() => {});

export const mockResizeObserver = () => {
	(window as any).ResizeObserver = class ResizeObserver {
		observe() {}
		disconnect() {}
	};
};

export const mockElementOffset = () => {
	const originalOffsetHeight = Object.getOwnPropertyDescriptor(
		HTMLElement.prototype,
		'offsetHeight'
	);
	const originalOffsetWidth = Object.getOwnPropertyDescriptor(
		HTMLElement.prototype,
		'offsetWidth'
	);

	beforeAll(() => {
		Object.defineProperty(HTMLElement.prototype, 'offsetHeight', {
			configurable: true,
			value: 500,
		});
		Object.defineProperty(HTMLElement.prototype, 'offsetWidth', {
			configurable: true,
			value: 500,
		});
	});

	afterAll(() => {
		Object.defineProperty(
			HTMLElement.prototype,
			'offsetHeight',
			originalOffsetHeight
		);
		Object.defineProperty(
			HTMLElement.prototype,
			'offsetWidth',
			originalOffsetWidth
		);
	});
};

// Test whether logged object has certain props
export const logContain = async (props: any) => {
	await waitFor(() =>
		expect(jestLog).toHaveBeenLastCalledWith(expect.objectContaining(props))
	);
};

interface LogObject {
	text?: string;
	tag?: string;
	anvilComponent?: string;
	textSource?: string;
}

export const expectLog = async (obj: LogObject) => {
	logActiveElement();
	await logContain(obj);
};

// Legacy keypress supprt for those components that relied on event.code, which is unsupported by user-events@v14
export const keypressLegacy = (el: any, key: string) => {
	const codeToWhich = {
		Tab: 9,
		Enter: 13,
		Shift: 16,
		Escape: 27,
		Space: 32,
		ArrowLeft: 37,
		ArrowUp: 38,
		ArrowRight: 39,
		ArrowDown: 40,
	};

	const which = (codeToWhich as any)[`${key}`];

	if (!which) {
		console.log(`Key "${key}" is not supported by keypressLegacy()`);
		return;
	}

	fireEvent.keyDown(el, {
		key,
		keyCode: which,
	});
};
